module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("45NJV"))).then(() => module.bundle.root('dsisd'));